
import React from 'react';
import styles from './CheckoutPage.m.sass';
import content from '../../components/content/Content.m.sass';

import cx from 'classnames';

import {connect} from 'react-redux';

import {applyCouponToCart, checkoutCart, removeCouponFromCart} from '../../ducks/cart';
import {getOrderPaymentData} from '../../ducks/order';

import {asMappedSubmissionError} from '../../utils/asSubmissionError';
import extractGaClientId from '../../utils/extractGaClientId';

import Meta from '../../components/meta/Meta';
import OrderPage from '../orderPage/OrderPage';
import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import Content from '../../components/content/Content';
import CheckoutForm from '../../components/checkout/CheckoutForm';
import GoBack from "../../components/goBack/GoBack";
import withMediaQueries from "../withMediaQueries/withMediaQueries";
import ErrorPage from '../errorPage/ErrorPage.js';


@connect(({cart}) => ({
  cart
}))
@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
export default class CheckoutPage extends React.PureComponent {
  checkout = ({customer, paymentMethod, details, additional_info, discount}) => {
    const {dispatch, cart} = this.props;

    const info = {...details, 'Additional Info': additional_info};

    const data = {
      customer: {
        email: customer.email
      },
      [`${customer.contact_method}_username`]: customer.contact_value,
      additional_info: Object.keys(info)
        .reduce((acc, it) => (acc.push(`${it}: ${info[it]}`), acc), [])
        .join('\n'),
      tos_accepted: 1,
      newsletter_subscribed: customer.newsletter_subscribed
    };

    let returnUrl;
    return dispatch(checkoutCart(cart.id, paymentMethod, data, undefined, cart.tokenValue))
      .then(orderResponse => dispatch(getOrderPaymentData(
        orderResponse.content.id,
        orderResponse.content.tokenValue,
        (returnUrl = OrderPage.getOrderUrl({...orderResponse.content, anonymous: cart.anonymous}, true)),
        extractGaClientId()
      )))
      .then(paymentDataResponse => {
        if (paymentMethod === 'offline') {
          window.location = returnUrl;
        } else {
          window.location = paymentDataResponse.content.url;
        }

        // Keep form locked until page transition
        return new Promise(() => {});
      })
      .catch(asMappedSubmissionError({
        'payments.0.method': 'checkoutMethod'
      }));
  };

  render() {
    const {dispatch, cart, collapsed} = this.props;

    if (!cart) {
      return (
        <ErrorPage>
          <h1>Your cart is empty :(</h1>
          <br/>
          <p>Buy something!</p>
        </ErrorPage>
      );
    }

    return (
      <div>
        <Meta fallbackTitle="Checkout"/>

        {collapsed && (
          <GoBack/>
        )}

        <Content>
          <div className={content.content_top}>
            <div className="container">
              <BreadcrumbsContainer
                append={[{name: "Checkout"}]}
                only
              />
            </div>
          </div>

          <div className="container">
            <div className={content.content_inner}>
              <CheckoutForm
                cart={cart}
                onSubmit={this.checkout}
                applyCoupon={coupon => dispatch(applyCouponToCart(coupon, cart.id, cart.tokenValue))}
                removeCoupon={() => dispatch(removeCouponFromCart(cart.id, cart.tokenValue))}
              />
            </div>
          </div>
        </Content>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/checkoutPage/CheckoutPage.js